import React, { createContext, useContext } from 'react';
import { useSurvey } from '../hooks/useSurvey';

const SurveyContext = createContext(null);

export const SurveyProvider = ({ inviteID, inTestMode = false, children }) => {
  const surveyState = useSurvey(inviteID, inTestMode);

  return (
    <SurveyContext.Provider value={{ ...surveyState, inTestMode }}>
      {children}
    </SurveyContext.Provider>
  );
};

export const useSurveyContext = () => {
  const context = useContext(SurveyContext);
  if (!context) {
    throw new Error('useSurveyContext must be used within a SurveyProvider');
  }
  return context;
};